import type { PropsWithChildren } from 'react';

import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import {
  type OmitKeyof,
  QueryClient,
  QueryClientProvider as BaseQueryClientProvider,
} from '@tanstack/react-query';
import {
  type PersistQueryClientOptions,
  PersistQueryClientProvider,
} from '@tanstack/react-query-persist-client';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: 0,
      staleTime: 1000 * 60 * 5,
    },
  },
});

const persistOptions: OmitKeyof<PersistQueryClientOptions, 'queryClient'> = {
  persister: createAsyncStoragePersister({
    storage: window.localStorage,
  }),
};

export default function QueryClientProvider({ children }: PropsWithChildren) {
  if (!import.meta.env.PROD) {
    return (
      <BaseQueryClientProvider client={queryClient}>
        {children}
      </BaseQueryClientProvider>
    );
  }

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={persistOptions}
    >
      {children}
    </PersistQueryClientProvider>
  );
}
